<div class="page-container">
  <div class="sidebar">
    <app-side-navbar></app-side-navbar>
  </div>

  <div class="landing-container">
    <div
      class="text-block top-lef"
      [class.active]="selectedLabel === 'Product Health' && menuVisible"
    >
      <h3>Product Health Index</h3>
      <p>How the product is now</p>
    </div>

    <div class="circle-container">
      <div class="center-circle">
        <div
          class="quadrant top-left"
          [class.active]="selectedLabel === 'Product Health' && menuVisible"
          (mouseenter)="onQuadrantEnter('Product Health')"
          (mouseleave)="onMouseLeave()"
          (click)="onQuadrantClick('Product Health', $event)"
        >
          <!-- <i class="fas fa-gauge-high icon"></i> -->
           <div class="mat-icon">
           <mat-icon class="icon">speedometer</mat-icon>
           </div>
        </div>

        <div
          class="quadrant top-right"
          [class.active]="selectedLabel === 'Ideation' && menuVisible"
          (mouseenter)="onQuadrantEnter('Ideation')"
          (mouseleave)="onMouseLeave()"
          (click)="onQuadrantClick('Ideation', $event)"
        >
          <i class="fas fa-lightbulb icon"></i>
        </div>

        <div
          class="quadrant bottom-left"
          [class.active]="
            selectedLabel === 'Product Improvement' && menuVisible
          "
          (mouseenter)="onQuadrantEnter('Product Improvement')"
          (mouseleave)="onMouseLeave()"
          (click)="onQuadrantClick('Product Improvement', $event)"
        >
          <i class="fas fa-gear icon"></i>
        </div>

        <div
          class="quadrant bottom-right"
          [class.active]="selectedLabel === 'Current Projects' && menuVisible"
          (mouseenter)="onQuadrantEnter('Current Projects')"
          (mouseleave)="onMouseLeave()"
          (click)="onQuadrantClick('Current Projects', $event)"
        >
          <i class="fas fa-clipboard-check icon"></i>
        </div>

        <div class="inner-circle">
          <span>Product<br />Health<br />Ecosystem</span>
        </div>
      </div>
    </div>

    <div
      class="text-block top-righ"
      [class.active]="selectedLabel === 'Ideation' && menuVisible"
    >
      <h3>Ideation</h3>
      <p>What's being planned to improve the product</p>
    </div>

    <div
      class="text-block bottom-lef"
      [class.active]="selectedLabel === 'Product Improvement' && menuVisible"
    >
      <h3>Product improvement</h3>
      <p>How will the product be in future</p>
    </div>

    <div
      class="text-block bottom-righ"
      [class.active]="selectedLabel === 'Current Projects' && menuVisible"
    >
      <h3>Current projects</h3>
      <p>What's being done to improve the product</p>
    </div>

    <div
      class="nav-box"
      *ngIf="menuVisible"
      (mouseenter)="onMenuEnter()"
      (mouseleave)="onMouseLeave()"
      [ngClass]="'nav-box-' + menuPosition"
    >
      <h3>{{ selectedLabel }}</h3>
      <ul>
        <li
          *ngFor="let item of menu[selectedLabel]"
          (click)="navigate(item)"
        >
          <mat-icon>{{ item.icon }}</mat-icon
          ><span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
